'use strict'

my_stuff_menu_template = require '../templates/my_stuff_menu.html.mustache'
my_stuff_layout_template = require '../../../components/mystuff_layout/templates/mystuff_layout.html.mustache'
user_nav_template = require '../templates/main.html.mustache'

{ addReferrer } = require '../../../../../src/frontend/helper/general/m_userSessionAddReferrer'
{ fetchUser } = require '../../../../../src/frontend/helper/user/fetchUser'
CartWidget = require '../../../../cart_widget/frontend/cart_widget'
SignInFlyout = require '../../signin_flyout/frontend/signin_flyout'
LanguageSelector = require '../../language_menu/frontend/language_selector'
{ matchMQ, addMQListener } = require '../../../../../src/frontend/helper/mediaQueries/mediaQueries'

APPS = {
  'mygroupons': 'ls-my-groupons'
  'clo': 'ls-my-linked-deals'
  'my_reservations': 'ls-my-reservations'
  'gdt-my-food': 'ls-my-food'
  'my_account': 'ls-my-account'
  'myprofile': 'ls-my-profile'
  'sub_center': 'ls-my-email-subs'
  'itier-ls-voucher-archive': 'ls-older-vouchers'
}

buildResponsiveMenu = ->
  if Groupon.PageFlags?.isLegacyResponsive
    Groupon.LS.responsiveMenu?()
  return

###*
# @public
###
removeCachedUserData = ->
  fetchUser.removeUserData()

setCartWidget = ->
  return if not document.querySelector('#ls-user-nav .cart-widget')
  new CartWidget '.cart-widget'

appendLanguageMenu = ->
  langMenu = document.getElementById('ls-lang-menu')
  return unless langMenu

  langMenu.classList.remove('ls-hide')
  new LanguageSelector()
  document.getElementById('user-help').insertAdjacentElement('afterend', langMenu)


updateSigninFlyoutPlacement = ->
  # Show the elements which are hidden on initial page load
  $('#ls-user-signin-with-flyout').removeClass('ls-hide-visibility')
  $('#ls-user-signup').removeClass('ls-hide')

  moveFlyoutsToUpperContainer = matchMQ "(max-width: 960px)"
  if not Groupon.PageFlags.isLegacyResponsive
    moveFlyoutsToUpperContainer = false
  toggleUserMenuPlacement(moveFlyoutsToUpperContainer)

toggleUserMenuPlacement = (moveFlyoutsToUpperContainer) ->
  selector = if moveFlyoutsToUpperContainer then '.user-menu' else '#ls-header-lower-signin-container'
  $(selector).append($('#user-name, #ls-my-stuff, #ls-header-signin-flyout-container'))

updateReferrerUrls = (scope) ->
  addReferrer(scope)
  # update the urls when the location changed
  window.addEventListener 'changestate', ->
    addReferrer(scope)


User =
  init: ->
    return unless (@userNav = document.getElementById('ls-user-nav'))
    @showNotificationsOnDesktop = Groupon.LS.experiments?.showNotificationsOnDesktop
    @showSigninFlyout = Groupon.LS.experiments?.showSigninFlyout
    @translations = Groupon.LS.translations?.userNav
    @country_US = (document.head.getAttribute('data-country') is 'US')
    @country_UK = (document.head.getAttribute('data-country') is 'GB')
    @hasLiteHeader = !!document.getElementById('ls-lite-header')
    brand = document.head.dataset.brand
    @showRVDMenu = @checkRVDMenu()
    @brand = {
      groupon: brand is 'groupon'
      livingsocial: brand is 'livingsocial'
    }
    @fetchWithTokenExchange()

  initFlyout: (user) ->
    SignInFlyout.init()
    @renderMyStuffMenu(user, 'ls-signin-flyout-mystuff-pane')
    SignInFlyout.bind()
    if Groupon.PageFlags.isLegacyResponsive
      addMQListener "(max-width: 960px)", (mq) ->
        toggleUserMenuPlacement(mq.matches)

  initInboxFlyout: ->
    flyout = document.getElementById('ls-header-inbox-flyout-container')
    return unless flyout
    flyout.classList.remove('ls-hide')

  checkRVDMenu: ->
    showRVDMenu = false
    if Cookie.get('c')
      showRVDMenu = true
      document.getElementById('ls-header-rvd-link')?.classList.remove('ls-hide')
    showRVDMenu

  fetchWithTokenExchange: ->
    fetchUser.exchangeTokenIfNeed ( => @fetch())

  fetch: ->
    noUser_cb = =>
      updateReferrerUrls()
      if @showSigninFlyout
        updateSigninFlyoutPlacement()
        @initFlyout()
      if @showNotificationsOnDesktop
        @initInboxFlyout()
      setCartWidget()
      appendLanguageMenu(false)
      buildResponsiveMenu()
      return

    hasUser_cb = (res) =>
      @renderUserNav res
      if @showSigninFlyout
        updateSigninFlyoutPlacement()
        @initFlyout(res)
      if @showNotificationsOnDesktop
        @initInboxFlyout()
      @renderMyStuffLayout res
#      Groupon.Modules.Header.bind()
      delete Groupon.Modules.Header
      setCartWidget()
      appendLanguageMenu(true)
      buildResponsiveMenu()
      return

    success = hasUser_cb

    {userId, hasUserData} = fetchUser.useStoredData(noUser_cb, hasUser_cb)
    return if hasUserData or not userId

    error = (err) ->
      noUser_cb()
      Groupon.Utils.trackEvent 'user-call-failed', err
      return

    fetchUser.fetch(userId, success, error)

  loadViewData: ->
    flagData = Groupon.LS.flags or {}
    Object.assign flagData, {
      showWishlist: Groupon.LS.flags?.showWishlist
      t:                      @translations
      country_US:             @country_US
      country_UK:             @country_UK
      showSigninFlyout:       @showSigninFlyout
      showRVDMenu:            @showRVDMenu
      showLiteHeader:         @hasLiteHeader
      showCart:               Groupon.Cart?.showCart
      cartWidgetUrl:          Groupon.Cart?.cartWidgetUrl
    }

  renderMyStuffMenu: (user, containerId) ->
    data = Object.assign {}, @loadViewData(), { user }
    data.t?.myProfileLink ?= '/myprofile'
    if not user
      linksToUpdate = ['myGrouponsLink', 'myCardLinkedDealsLink', 'myWishlistLink', 'myAccountLink', 'myProfileLink']
      Object.keys(data.t).filter((i) -> linksToUpdate.indexOf(i) > -1).forEach (key) ->
        link = data.t[key]
        data.t[key] = "/login?metric=layout_login&ref=#{encodeURIComponent(link)}"
        return
      data.t['signUpLink'] = data.t['signUpLink'] + "?metric=layout_login"

    $('#' + containerId).html my_stuff_menu_template.render data

  renderUserNav: (user) ->
    data = Object.assign {}, @loadViewData(), { user }
    $('#ls-user-nav').html user_nav_template.render data

    if @showSigninFlyout
      $('#ls-header-signin-flyout-container').remove()

    @renderMyStuffMenu user, 'ls-my-stuff'
    updateReferrerUrls('#ls-user-nav')

    # Enable CPP get started link in the main user navigation menu if user
    # has a "has_cpp" cookie, which is set when user visits /u/get-started once.
    # Link should also be displayed if user is participating in AB experiment.
    # This is a "temporary" solution and might be lifted later after launch.
    if Cookie.get('has_cpp') in ['1', 'true']
      $('#user-my-page').removeClass 'hidden'

    buildResponsiveMenu()

    $('#sign-out, #ls-resp-sign-out').one 'click', fetchUser.removeUserData
    return

  renderMyStuffLayout: (user) ->
    return unless ($myStuffSelector = $('#ls-my-stuff-wrapper')).length
    appName = document.head.dataset.app
    currentApp = APPS[appName]
    data = {
      user
      t:          @translations
      brand:      @brand
      country_US: @country_US
      country_UK: @country_UK
      enablePrivacyCenter: Groupon.LS.flags?.enablePrivacyCenter
    }
    $myStuffSelector.html my_stuff_layout_template.render data
    document.getElementById(currentApp)?.classList.add('active')

Groupon.LS = (Groupon.LS || {})
Groupon.LS.User = (Groupon.LS.User || {})
Object.assign(Groupon.LS.User, { removeCachedUserData })

module.exports = {
  User
}
